// ------------------------------------------------------------------------------
// CustomSelect
// author: mudas
// created: 2024/12/4
// ------------------------------------------------------------------------------

import React, { FC, ReactElement } from 'react';
import { useControllableValue } from 'ahooks';

import { Select, SelectProps } from '@fuxi/eevee-ui';
import { BaseOptionType, DefaultOptionType } from 'rc-select/es/Select';

export type SelectCallback<OptionType> = (option: OptionType) => void;

export interface IProps<ValueType = any, OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType>
  extends Omit<SelectProps<ValueType, OptionType>, 'dropdownRender'> {
  dropdownRender: (callback: SelectCallback<OptionType>) => ReactElement;
}

const CustomSelect: FC<IProps> = props => {
  const { dropdownRender, popupMatchSelectWidth = false, ...otherProps } = props;

  const [value, setValue] = useControllableValue(props);

  const [open, setOpen] = useControllableValue<boolean>(props, {
    valuePropName: 'open',
    trigger: 'onDropdownVisibleChange',
  });

  // 选中指定选项
  const handleSelect = (value: any | any[]) => {
    setOpen(false);
    setValue(value);
  };

  // 自定义渲染包装
  const dropdownRenderWrap = () => {
    return dropdownRender(handleSelect);
  };

  return (
    <Select
      {...otherProps}
      // value 有 Form.Item 在外部进行代理，此处 open 需要内部自行设定和更新
      open={open}
      onDropdownVisibleChange={setOpen}
      popupMatchSelectWidth={popupMatchSelectWidth}
      dropdownRender={dropdownRenderWrap}
    />
  );
};

export default CustomSelect;
